import React from 'react'
import styled from 'styled-components'
import GroupMetricForm from 'pages/shared/GroupMetricForm'

import { PageHeader, PageTitle, SinglePanePage, screenSize } from 'styles/shared'
import { defaultGroupMetric } from 'models/GroupMetric'

const AddGroupMetric = () => {
  return (
    <>
      <PageHeader>
        <S.PageTitle>New Group Metric</S.PageTitle>
      </PageHeader>
      <S.SinglePanePage>
        <GroupMetricForm
          saveMethod={'create'}
          groupMetric={defaultGroupMetric}
        />
      </S.SinglePanePage>
    </>
  )
}

export default AddGroupMetric

const S = {
  SinglePanePage: styled(SinglePanePage)`
    @media ${screenSize.small} {
      margin-top: 0;
    }
  `,
  PageTitle: styled(PageTitle)`
    @media ${screenSize.small} {
      display: block;
    }
  `
}
